import { all, takeEvery, call, put, fork } from 'redux-saga/effects'
import gocarActions from './actions'
import callApi from '../../helpers/api'
import urls from '../../request/urls/url'
import authGet from '../../request/methods/authGet'

export function* registerGocarSimpleRequest() {
  yield takeEvery('REGISTER_GOCAR_SIMPLE', function*(payload) {
    const res = yield call(callApi.registerGocarSimple, payload)
    if (res) {
      yield put({type: gocarActions.REGISTER_STATUS, data: res.data})
    }
  })
}

export function * validateReferral () {
  yield takeEvery(gocarActions.VALIDATE_REFERRAL_REQUEST, function * ({ payload }) {
    try {
      let res = yield call(authGet, { ...payload, url: urls.validateReferral })
      if (res.status === 200) {
        yield put({
          type: gocarActions.VALIDATE_REFERRAL_SUCCESS,
          data: res.data || []
        })
      } else {
        yield put({
          type: gocarActions.VALIDATE_REFERRAL_FAILURE,
          data: []
        })
      }
    } catch (e) {
      yield put({
        type: gocarActions.VALIDATE_REFERRAL_FAILURE,
        data: []
      })
    }
  })
}

export default function* rootSaga() {
  yield all([
    fork(registerGocarSimpleRequest),
    fork(validateReferral)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/register/saga.js